import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Md5 } from 'ts-md5/dist/md5';
import { UsuarioModel } from '~shared/models/usuario';
import { AuthService } from '~shared/servicios/auth.service';
import { ServicesService } from '../../shared/servicios/services.service';

@Component({
  selector: 'app-login3',
  templateUrl: './login3.component.html',
  styleUrls: ['./login3.component.scss']
})
export class Login3Component implements OnInit {

  parametro: any;

  constructor(private route: ActivatedRoute, private services: ServicesService, private auth: AuthService, private router: Router) {
    this.parametro = this.route.snapshot.paramMap.get('tokey');
    console.log(this.parametro);
  }

  ngOnInit(): void {
    this.services.getDataLogin(this.parametro).subscribe(data => {
      // console.log(data);
      const usuario = this.setObjectUserLogin(data[0].usuario, data[0].pswd);
      const password = Md5.hashStr(usuario.psw);
      usuario.psw = password.toString();
      // console.log(usuario);

      this.auth.login(usuario, false).subscribe(resp => {
        // console.log(resp);
        if (resp[0].key !== 'Error') {
          this.router.navigateByUrl(data[0].destino);
        }
      }, (err) => {

      });
    });
  }

  setObjectUserLogin(user: any, pass: any): UsuarioModel {
    return {
      usuario: user,
      psw: pass,
    };
  }

}
